import { Category } from '@models/category.model';

export const mapCategoryToUpdateRequest = (category: Category) => {
  const {createdAt, ...updateRequest} = category;
  return updateRequest;
};
